export const CHECK_INTERVAL = 120000; // 2 minutes;
export const DAILY_EMAIL_SEND_LIMIT_WARNING_KEY = 'dailyEmailSendQuota';

export const CLOSE_EXCEED_LIMIT = 50;
export const SUPER_CLOSE_EXCEED_LIMIT = 10;
